import React from "react"

export type NoteContentLeadingProps = {
  children: React.ReactNode
}

export function NoteContentLeading({ children }: NoteContentLeadingProps) {
  return (
    <div
      className="[grid-area:icon] flex items-center justify-center"
      data-slot="note-content-leading"
    >
      {children}
    </div>
  )
}
